// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const giratina_altered: PokeData = {
  "id": 487,
  "name": "giratina-altered",
  "height": 45,
  "weight": 7500,
  "base_experience": 306,
  "types": [
    PokeType.GHOST,
    PokeType.DRAGON
  ],
  "api_moves": [
    "slash",
    "scary-face",
    "destiny-bond",
    "pain-split",
    "dragon-breath",
    "ancient-power",
    "dragon-claw",
    "heal-block",
    "aura-sphere",
    "earth-power",
    "shadow-claw",
    "shadow-sneak",
    "defog",
    "ominous-wind",
    "shadow-force",
    "hex"
  ],
  "moves": [
    "scary-face",
    "dragon-breath",
    "ancient-power",
    "dragon-claw",
    "earth-power",
    "shadow-sneak",
    "night-shade",
    "spectral-chain",
    "lick",
    "confuse-ray",
    "draco-meteor",
    "curse",
    "shadow-dagger"
  ],
  "evolution_chain": {
    "id": 248,
    "item": null,
    "species": [
      {
        "name": "giratina",
        "order": 488,
        "types": [
          PokeType.GHOST,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 166,
    "speed": 111,
    "ability_power": 123
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
